// extracted by mini-css-extract-plugin
export var card = "TableOfContents-module--card--2b58a";
export var current = "TableOfContents-module--current--bebb5";
export var item = "TableOfContents-module--item--78b81";
export var list = "TableOfContents-module--list--fef77";
export var title = "TableOfContents-module--title--fd000";
export var wrap = "TableOfContents-module--wrap--40075";